<div class="modal-backdrop" *ngIf="isVisible" (click)="onClose()"></div>
<div class="modal" *ngIf="isVisible">
  <div class="modal-header">
    <h3>{{ isEditMode ? 'Edit Storage Hub' : (isDuplicateMode ? 'Duplicate Storage Hub' : 'Add New Storage Hub') }}</h3>
    <button class="close-btn" (click)="onClose()" [disabled]="isSaving">×</button>
  </div>
  <div class="modal-body">
    <div class="form-row">
      <label>Location Name <span style="color: red;">*</span></label>
      <input type="text" [(ngModel)]="form.location_name" placeholder="e.g., North Dallas Hub" required />
    </div>

    <div class="form-row">
      <label>Location Type <span style="color: red;">*</span></label>
      <select [(ngModel)]="form.location_type" [disabled]="isLoadingTypes" required>
        <option value="" selected disabled>{{ isLoadingTypes ? 'Loading...' : 'Select Location Type' }}</option>
        <ng-container *ngFor="let type of locationTypes">
          <option *ngIf="type.CodeName.toLowerCase() !== 'substation'" [value]="type.CodeName">
            {{ type.CodeDesc || type.CodeName }}
          </option>
        </ng-container>
      </select>
    </div>

    

    <div class="form-row">
      <label>Description <span style="color: red;">*</span></label>
      <input type="text" [(ngModel)]="form.location_desc" placeholder="Short description of the location" required />
    </div>

    <div class="form-row">
      <label>Latitude <span style="color: red;">*</span></label>
      <input type="number" [(ngModel)]="form.location_latitude_value" step="any" placeholder="e.g., 35.2271"
        [class.input-error]="errors.latitude" />
      <span class="field-error" *ngIf="errors.latitude">{{ errors.latitude }}</span>
    </div>

    <div class="form-row">
      <label>Longitude <span style="color: red;">*</span></label>
      <input type="number" [(ngModel)]="form.location_longitude_value" step="any" placeholder="e.g., -80.8431"
        [class.input-error]="errors.longitude" />
      <span class="field-error" *ngIf="errors.longitude">{{ errors.longitude }}</span>
    </div>

    <div class="toggle-grid">
      <label><input type="checkbox" [(ngModel)]="form.is_direct_update_allowed" /> Allow Direct Updates</label>
      <label><input type="checkbox" [(ngModel)]="form.is_transfer_allowed" /> Allow Transfers</label>
      <label><input type="checkbox" [(ngModel)]="form.is_mat_allocation_source" /> Is Allocation Source</label>
    </div>

    <div class="error" *ngIf="errorMessage">{{ errorMessage }}</div>
  </div>
  <div class="modal-footer">
    <button class="secondary" (click)="onClose()" [disabled]="isSaving">Cancel</button>
    <button class="primary" (click)="saveHub()" [disabled]="isSaving">{{ isSaving ? 'Saving...' : 'Save Hub' }}</button>
  </div>
</div>
